import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

export default function FiltersCheckbox({
  id,
  disabled,
  checked,
  label,
  color,
  checkedMarkColor,
  styles,
}) {
  return (
    <CheckboxContainer>
      <HiddenCheckbox id={id} checked={checked} disabled={disabled} aria-label={label} />
      <StyledCheckbox
        className={`checkbox__container ${checked ? "checkbox__container--checked" : ""}`}
        checked={checked}
        styles={styles}
      >
        <Icon color={checkedMarkColor || color} viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  );
}

const CheckboxContainer = styled.div`
  display: flex;
  vertical-align: middle;
  margin-right: 10px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({type: "checkbox"})`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${({color}) => color || "black"};
  stroke-width: 4px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 17px;
  height: 17px;
  background: white;
  transition: all 150ms;
  border: ${({styles}) => styles?.border || "1px solid #999"};
  border-radius: ${({styles, theme}) =>
    styles?.borderRadius || theme.v2.decoration.border.radius.default};

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }

  ${Icon} {
    visibility: ${({checked}) => (checked ? "visible" : "hidden")};
  }
`;

const defaultStyles = {};

FiltersCheckbox.defaultProps = {
  styles: defaultStyles,
};

FiltersCheckbox.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
  checkedMarkColor: PropTypes.string,
  styles: PropTypes.shape({}),
};
